// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  villageId: __t.u64().primaryKey().name("village_id"),
  worldId: __t.u64().name("world_id"),
  tune: __t.u8(),
  startedAt: __t.timestamp().name("started_at"),
  by: __t.string(),
});
